module.exports = __webpack_public_path__ + "static/media/PIJL_06.9f612937.png";